/* import __COLOCATED_TEMPLATE__ from './intl-split.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@ember/component';
import { htmlSafe } from '@ember/template';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { splitNode } from '@square/dashboard-translations/utils/split-translation';

/**
## intl-split

Allows for interpolating HTML into a template.

### Example

```example
@title Basic usage

@controller-properties
{
  // These are the segments you would get with the template
  // `Text before the link [[#link]]First text in the link [[#strong]]text in the strong[[/strong]], final text in the link[[/link]] text after the link`
  segments: [
    { text: 'Text before the link ' },
    {
      key: 'link',
      content: [
        { text: 'First text in the link ' },
        { key: 'strong', content: [{ text: 'text in the strong' }] },
        { text: ', final text in the link'}
      ]
    },
    { text: ' text after the link' }
  ]
}

@hbs
{{#intl-split "translation.key" (hash name=this.name)  as |segment|~}}
  {{~#if (eq segment.key "link")~}}
    <a href="squareup.com">
      {{~#segment.content as |innerSegment|~}}
        {{~#if (eq innerSegment.key "strong")~}}
          <strong>
            {{~innerSegment.content~}}
          </strong>
        {{~/if~}}
      {{~/segment.content~}}
    </a>
  {{~/if~}}
{{~/intl-split}}
```

### Parameters
@param {String} translationKey The translation key that identifies the template.
@param {Object} [options=undefined] The options that get used for the translation.
@param {Boolean} [useIntlCountry=false] Whether to use intlCountry service instead of intl
*/

function htmlSafeHelper(segment) {
  if (segment.content) {
    return {
      key: segment.key,
      content: segment.content.map(htmlSafeHelper)
    };
  } else {
    return {
      text: htmlSafe(segment.text)
    };
  }
}
let IntlSplit = (_dec = computed('intl.t', 'intlCountry.t', 'options', 'translationKey', 'useIntlCountry'), (_class = (_class2 = class IntlSplit extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "intlCountry", _descriptor2, this);
    _defineProperty(this, "tagName", '');
  }
  get segments() {
    const service = this.useIntlCountry ? this.intlCountry : this.intl;
    const translated = service.t(this.translationKey, this.options);
    return splitNode(translated).map(htmlSafeHelper);
  }
}, _defineProperty(_class2, "positionalParams", ['translationKey', 'options']), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intlCountry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "segments", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "segments"), _class.prototype)), _class));
export { IntlSplit as default };